import { remapEmojiName } from 'state/emoji/helpers'

export const format = item => ({
    ...item,
    name: remapEmojiName(item.name)
})